import { render, staticRenderFns } from "./PessoaInterfaceApiForm.vue?vue&type=template&id=1e962024"
import script from "./PessoaInterfaceApiForm.vue?vue&type=script&lang=js"
export * from "./PessoaInterfaceApiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports